export default class LoaderActions {
  static PAGE_LOADING = "PAGE_LOADING";
  static PAGE_LOADED = "PAGE_LOADED";
  static SELECT_LOADER = "SELECT_LOADER";
}
